function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'reactstrap';
import ScrollTarget from '../elements/ScrollTarget';
import Box from './Box';
import Theme from '../modules/Theme';
export var makeSection = function makeSection(title, target, color, icon) {
  return {
    color: color,
    icon: icon,
    target: target,
    title: title
  };
};
export var sectionPropTypes = {
  color: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  target: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired
};

var Section = function Section(_ref) {
  var children = _ref.children,
      section = _ref.section,
      title = _ref.title,
      overview = _ref.overview,
      passThroughProps = _objectWithoutProperties(_ref, ["children", "section", "title", "overview"]);

  var scrollTarget;

  if (section) {
    scrollTarget = /*#__PURE__*/React.createElement(ScrollTarget, {
      name: section.target
    });
  }

  return /*#__PURE__*/React.createElement("div", null, scrollTarget, /*#__PURE__*/React.createElement(Box, passThroughProps, /*#__PURE__*/React.createElement(Row, {
    style: {
      textAlign: 'center'
    }
  }, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("h2", null, title), /*#__PURE__*/React.createElement("p", {
    style: {
      color: Theme.primaryDark,
      fontWeight: 'bold'
    }
  }, overview))), children));
};

export default Section;